import { settingsMyAccountActions } from 'actions/modules/myAccount';

export default (() => {  

  const getFavoriteInsights = () => (_, getState) => getState().myAccountState.settingsState.favoriteInsights

  const addToFavorites = ({ fileName, groupName, updateSettingsCall, ...rest }) => dispatch => {
    const favoriteInsights = dispatch(getFavoriteInsights()),
          newFavoriteInsights = favoriteInsights.add({ fileName, groupName, favorite: true, ...rest })
    dispatch(settingsMyAccountActions.changeSetting(newFavoriteInsights, 'favoriteInsights'))
    updateSettingsCall({ settings: { favoriteInsights: JSON.stringify(newFavoriteInsights) } })
  }

  const removeFromFavorites = ({ fileName, groupName, updateSettingsCall }) => dispatch => {
    const favoriteInsights = dispatch(getFavoriteInsights()),
          newFavoriteInsights = favoriteInsights.removeByProps({ fileName, groupName })
    dispatch(settingsMyAccountActions.changeSetting(newFavoriteInsights, 'favoriteInsights'))
    updateSettingsCall({ settings: { favoriteInsights: JSON.stringify(newFavoriteInsights) } })
  }

  const ACTIVE_VIEWS = {
    LIST: "LIST",
    TILES: "TILES"
  }

  return {
    addToFavorites,
    removeFromFavorites,
    ACTIVE_VIEWS
  }
})()
